type WeekDay =
    | 'Monday'
    | 'Tuesday'
    | 'Wednesday'
    | 'Thursday'
    | 'Friday'
    | 'Saturday'
    | 'Sunday';

const WEEKDAYS_ORDER: WeekDay[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];

/**
 * Sorts an array of weekday strings according to standard week order (Monday to Sunday)
 * @param days - Array of weekday strings to sort
 * @returns New array with weekdays sorted in standard order
 * @example
 * ```ts
 * const sortedDays = orderWeekDays(['Sunday', 'Monday', 'Wednesday']);
 * console.log(sortedDays); // ['Monday', 'Wednesday', 'Sunday']
 * ```
 */
export function orderWeekDays(days: string[]): string[] {
    return [...days].sort(
        (a, b) =>
            WEEKDAYS_ORDER.indexOf(a as WeekDay) -
            WEEKDAYS_ORDER.indexOf(b as WeekDay),
    );
}
